<template>
  <agent-default>
    <travel-plan-select-page channel="agent" />
  </agent-default>
</template>

<script>
import AgentDefault from '@/components/layout/AgentDefault';
import TravelPlanSelectPage from '@/components/travel/TravelPlanSelectPage';

export default {
  name: 'AgentTravelPlanSelect',
  components: { AgentDefault, TravelPlanSelectPage },
  metaInfo: { title: 'Travel — Get Quote' },
};
</script>
